import EStrikeStrikeZone from './EStrikeStrikeZone';

export default EStrikeStrikeZone;
